import React, { ReactElement } from 'react';
import { SelectServiceDatePageViewProps } from './SelectServiceDatePageViewProps';
import { Form } from '../../modules/forms/Form';
import { DatePickerField } from '../../modules/forms/fields/DatePiclerField';

export function SelectServiceDatePageVwView({
  initialFormData,
  formRef,
  availableDates,
  firstBookableDate,
  lastBookableDate,
  schema,
  onDateChange,
}: SelectServiceDatePageViewProps): ReactElement {
  return (
    <Form schema={schema} defaultValues={initialFormData} ref={formRef}>
      <DatePickerField
        name="selectedServiceDate"
        availableDates={availableDates}
        minDate={firstBookableDate}
        maxDate={lastBookableDate}
        onChange={onDateChange}
      />
    </Form>
  );
}
